import React, { useEffect, useRef, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { editEvent, viewEvent } from "../../Redux/Actions/eventActions";
import AddImage from "../../Global Functions/addImage";
import {
  viewCountryList,
  viewCityList,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import { viewBuilderList } from "../../Redux/Actions/builderActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { ToFirstCapital } from "../../Utils/helpers";
import MapsAddress from "../../Global Functions/mapsAddress";
import "./editEvents.css";

const EditEvents = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const startDateRef = useRef(null);
  const dispatch = useDispatch();

  const [selectedType, setSelectedType] = useState("");
  const [guestData, setGuestData] = useState({
    name: "",
    image: "",
    designation: "",
    organization: "",
  });

  const [trailerVideoData, setTrailerVideoData] = useState({
    url: "",
    type: "video",
    index: 0,
  });

  const [threeSixtyData, setThreeSixtyData] = useState({
    configuration: "",
    iframe_url: "",
    is_user_vr: true,
  });

  const [videoUploading, setVideoUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [eventPayload, setEventPayload] = useState({
    id: id,
    type: "",
    event_name: "",
    event_image: "",
    start_date: "",
    start_time: "",
    start_date_utc: "",
    end_date: "",
    end_time: "",
    end_date_utc: "",
    builder: "",
    lat: "",
    lng: "",
    about_event: "",
    address: "",
    cover_photo: "",
    guest_list: [
      {
        name: "",
        image: "",
        designation: "",
        organization: "",
      },
    ],
    country: "",
    state: "",
    city: "",
    youtube_link: "",
    video: "",
    image: [],
    trailer_videos: [],
    three_sixty: [],
  });

  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { builders } = useSelector((state) => state.builders || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { event } = useSelector((state) => state.events || {});

  const isComingSoon = selectedType?.toLowerCase() === "coming_soon";
  const isTrailer = selectedType?.toLowerCase() === "trailer";

  const handleNavigationAddTeam = () => {
    navigate("/event");
  };

  const buildUTCDateTime = (date, time) => {
    if (!date || !time) return "";

    const [year, month, day] = date.split("-").map(Number);
    const [hours, minutes] = time.split(":").map(Number);

    const utcMillis = Date.UTC(year, month - 1, day, hours, minutes) - 330 * 60 * 1000;

    const utcDate = new Date(utcMillis);

    if (isNaN(utcDate.getTime())) return "";

    return utcDate.toISOString();
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;

    setEventPayload((prevData) => {
      const updatedPayload = {
        ...prevData,
        [name]: value,
      };

      if (name === "country") {
        updatedPayload.state = "";
        updatedPayload.city = "";
      }

      if (name === "state") {
        updatedPayload.city = "";
      }

      updatedPayload.start_date_utc = buildUTCDateTime(
        updatedPayload.start_date,
        updatedPayload.start_time
      );

      updatedPayload.end_date_utc = buildUTCDateTime(
        updatedPayload.end_date,
        updatedPayload.end_time
      );

      if (
        ["start_time", "end_time", "start_date", "end_date"].includes(name) &&
        updatedPayload.start_date &&
        updatedPayload.end_date &&
        updatedPayload.start_date === updatedPayload.end_date &&
        updatedPayload.start_time &&
        updatedPayload.end_time &&
        updatedPayload.start_time > updatedPayload.end_time
      ) {
        toast.error("Start time cannot be after end time on the same day.");
        return prevData;
      }

      return updatedPayload;
    });
  };

  const guestAdditionHandler = (event) => {
    event.preventDefault();
    if (guestData?.name?.trim()) {
      setEventPayload((prev) => ({
        ...prev,
        guest_list: [...(prev.guest_list || []), guestData],
      }));
      toast.success("Guest Added Successfully!!");
      setGuestData({
        name: "",
        image: "",
        designation: "",
        organization: "",
      });
    } else {
      toast.error("Problem adding Guest!!");
    }
  };

  const handleGuestAdd = (event) => {
    const { name, value } = event.target;
    setGuestData((prevData) => ({ ...prevData, [name]: value }));
  };

  const CLEARABLE_FIELDS = ["youtube_link", "video", "event_image"];
  const CLEARABLE_ARRAYS = ["trailer_videos", "three_sixty"];

  const cleanPayload = (payload) => {
    const isEmpty = (value) =>
      value === "" || value === null || value === undefined;

    const isGuestEmpty = (guest) =>
      Object.values(guest).every((val) => isEmpty(val));

    const cleaned = {};

    for (const [key, value] of Object.entries(payload)) {
      if (CLEARABLE_FIELDS.includes(key)) {
        cleaned[key] = value ?? "";            
      } else if (CLEARABLE_ARRAYS.includes(key)) {
        cleaned[key] = Array.isArray(value) ? value : [];   
      } else if (key === "guest_list" && Array.isArray(value)) {
        cleaned[key] = value.filter((guest) => !isGuestEmpty(guest));
      } else if (Array.isArray(value) && value.length > 0) {
        cleaned[key] = value;
      } else if (!isEmpty(value)) {
        cleaned[key] = value;
      }
    }

    return cleaned;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!eventPayload.type) {
      toast.error("You have to select Event type");
      return;
    }

    if (!eventPayload.event_name?.trim()) {
      toast.error(isTrailer ? "Trailer Name is required" : "Event Name is required");
      return;
    }

    if (!eventPayload.about_event?.trim()) {
      toast.error("About is required");
      return;
    }

    if (!eventPayload.start_date) {
      toast.error("Start Date is required");
      return;
    }

    if (!eventPayload.start_time) {
      toast.error("Start Time is required");
      return;
    }

    if (!eventPayload.end_date) {
      toast.error("End Date is required");
      return;
    }

    if (!eventPayload.end_time) {
      toast.error("End Time is required");
      return;
    }

    if (!eventPayload.cover_photo?.trim()) {
      toast.error(
        isTrailer ? "Cover Photo is required for Trailer" : "Cover Photo is required"
      );
      return;
    }

    if (isTrailer && (!eventPayload.trailer_videos || eventPayload.trailer_videos.length === 0)) {
      toast.error("At least one Trailer Video is required");
      return;
    }

    if (isComingSoon && !eventPayload.builder?.trim()) {
      toast.error("Builder is required for Coming Soon events");
      return;
    }

    const finalPayload = {
      ...eventPayload,
      start_date_utc: buildUTCDateTime(eventPayload.start_date, eventPayload.start_time),
      end_date_utc: buildUTCDateTime(eventPayload.end_date, eventPayload.end_time),
      country:
        typeof eventPayload.country === "object"
          ? eventPayload.country?._id || ""
          : eventPayload.country,
      state:
        typeof eventPayload.state === "object"
          ? eventPayload.state?._id || ""
          : eventPayload.state,
      city:
        typeof eventPayload.city === "object"
          ? eventPayload.city?._id || ""
          : eventPayload.city,
    };

    const cleanedPayload = cleanPayload(finalPayload);

    try {
      const response = await dispatch(editEvent(cleanedPayload));
      if (response?.statusCode === 200) {
        navigate("/event");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    dispatch(viewCountryList({ page: 1, limit: 250 }));
  }, [dispatch]);

  useEffect(() => {
    const countryId =
      typeof eventPayload.country === "object"
        ? eventPayload.country?._id
        : eventPayload.country;

    if (countryId) {
      dispatch(viewStateListPagination({ country: countryId }));
    }
  }, [dispatch, eventPayload.country]);

  useEffect(() => {
    const countryId =
      typeof eventPayload.country === "object"
        ? eventPayload.country?._id
        : eventPayload.country;

    const stateId =
      typeof eventPayload.state === "object"
        ? eventPayload.state?._id
        : eventPayload.state;

    if (countryId && stateId) {
      dispatch(
        viewCityList({
          page: 1,
          limit: 200,
          state: stateId,
          country: countryId,
        })
      );
    }
  }, [dispatch, eventPayload.country, eventPayload.state]);

  useEffect(() => {
    const builderPayload = {
      page: 1,
      limit: 1000,
      is_deleted: false,
    };
    dispatch(getEnums());
    dispatch(viewBuilderList(builderPayload));
  }, [dispatch]);

  const addHoursToTime = (timeStr, hoursToAdd) => {
    if (!timeStr) return "00:00";
    let [h, m] = timeStr.split(":").map(Number);
    h += hoursToAdd;
    if (h >= 24) h = 23;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  useEffect(() => {
    dispatch(viewEvent(id));
  }, [dispatch, id]);

  const defaultPayload = {
    id: id,
    type: "",
    event_name: "",
    event_image: "",
    start_date: "",
    start_time: "",
    start_date_utc: "",
    end_date: "",
    end_time: "",
    end_date_utc: "",
    builder: "",
    lat: "",
    lng: "",
    about_event: "",
    address: "",
    cover_photo: "",
    guest_list: [],
    country: "",
    state: "",
    city: "",
    youtube_link: "",
    video: "",
    image: [],
    trailer_videos: [],
    three_sixty: [],
  };

  useEffect(() => {
    if (event?.data) {
      const countryValue =
        typeof event.data.country === "object"
          ? event.data.country?._id || ""
          : event.data.country || "";

      const stateValue =
        typeof event.data.state === "object"
          ? event.data.state?._id || ""
          : event.data.state || "";

      const cityValue =
        typeof event.data.city === "object"
          ? event.data.city?._id || ""
          : event.data.city || "";

      setEventPayload({
        ...defaultPayload,
        ...event.data,
        country: countryValue,
        state: stateValue,
        city: cityValue,
        address: event.data.address || "",
        lat: event.data.lat || "",
        lng: event.data.lng || "",
        start_date: event.data.start_date || "",
        end_date: event.data.end_date || "",
        start_time: event.data.start_time || "",
        end_time: event.data.end_time || "",
        start_date_utc:
          buildUTCDateTime(event.data.start_date, event.data.start_time),
        end_date_utc:
          buildUTCDateTime(event.data.end_date, event.data.end_time),
        video: event.data.trailer_videos?.[0] || event.data.video || "",
        trailer_videos: event.data.trailer_videos || [],
        three_sixty: event.data.three_sixty || [],
        youtube_link: event.data.youtube_link || "",
      });

      setSelectedType(event.data.type || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event?.data]);

  const handleAddressChange = ({ address, lat, lng, country, state, city }) => {
    setEventPayload((prev) => ({
      ...prev,
      address: address || "",
      lat: lat || "",
      lng: lng || "",
      country: country || prev.country,
      state: state || prev.state,
      city: city || prev.city,
    }));
  };

  const validImageTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/svg+xml",
  ];

  const validVideoTypes = [
    "video/mp4",
    "video/avi",
    "video/mov",
    "video/wmv",
    "video/mkv",
    "video/webm",
  ];

  const handleMediaUpload = async (event, targetKey, mediaType) => {
    const uploadedFile = event.target.files[0];
    if (!uploadedFile) {
      toast.error("No File Uploaded");
      return;
    }

    const validTypes = mediaType === "image" ? validImageTypes : validVideoTypes;

    if (!validTypes.includes(uploadedFile.type)) {
      toast.error(`Only ${mediaType} files are allowed!`);
      event.target.value = "";
      return;
    }

    if (targetKey === "video") {
      setVideoUploading(true);
      setUploadProgress(0);

      const progressInterval = setInterval(() => {
        setUploadProgress((prev) => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + 10;
        });
      }, 300);

      const responseUrl = await AddImage(uploadedFile);
      clearInterval(progressInterval);
      setUploadProgress(100);

      if (responseUrl) {
        setEventPayload((prevData) => ({ ...prevData, [targetKey]: responseUrl }));
        event.target.value = "";
      }

      setVideoUploading(false);
      setTimeout(() => setUploadProgress(0), 1000);
    } else if (targetKey === "trailer_video") {
      setVideoUploading(true);
      setUploadProgress(0);

      const progressInterval = setInterval(() => {
        setUploadProgress((prev) => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + 10;
        });
      }, 300);

      const responseUrl = await AddImage(uploadedFile);
      clearInterval(progressInterval);
      setUploadProgress(100);

      if (responseUrl) {
        setTrailerVideoData((prevData) => ({
          ...prevData,
          url: responseUrl,
        }));
        event.target.value = "";
        toast.success("Video uploaded successfully!");
      }

      setVideoUploading(false);
      setTimeout(() => setUploadProgress(0), 1000);
    } else {
      const responseUrl = await AddImage(uploadedFile);
      if (responseUrl) {
        if (targetKey === "guest_image") {
          setGuestData((prevData) => ({ ...prevData, image: responseUrl }));
        } else if (targetKey === "image") {
          setEventPayload((prevData) => ({
            ...prevData,
            image: [...(prevData.image || []), responseUrl],
          }));
        } else {
          setEventPayload((prevData) => ({ ...prevData, [targetKey]: responseUrl }));
        }
        event.target.value = "";
      }
    }
  };

  const handleRemoveVideo = () => {
    setEventPayload((prevData) => ({ ...prevData, video: "" }));
  };

  const addTrailerVideoHandler = (event) => {
    event.preventDefault();

    if (trailerVideoData.url.trim()) {
      setEventPayload((prev) => ({
        ...prev,
        trailer_videos: [
          ...(prev.trailer_videos || []),
          {
            url: trailerVideoData.url,
            type: "video",
            index: prev.trailer_videos?.length || 0,
          },
        ],
      }));
      toast.success("Trailer Video Added Successfully!!");
      setTrailerVideoData({
        url: "",
        type: "video",
        index: 0,
      });
    } else {
      toast.error("Please provide a video URL!!");
    }
  };

  const removeTrailerVideo = (index) => {
    setEventPayload((prevData) => ({
      ...prevData,
      trailer_videos: prevData.trailer_videos.filter((_, i) => i !== index),
    }));
    toast.success("Trailer Video Removed!");
  };

  const addThreeSixtyHandler = (event) => {
    event.preventDefault();

    if (threeSixtyData.configuration.trim() && threeSixtyData.iframe_url.trim()) {
      setEventPayload((prev) => ({
        ...prev,
        three_sixty: [...(prev.three_sixty || []), threeSixtyData],
      }));
      toast.success("360 Content Added Successfully!!");
      setThreeSixtyData({
        configuration: "",
        iframe_url: "",
        is_user_vr: true,
      });
    } else {
      toast.error("Please fill in all required fields!!");
    }
  };

  const removeThreeSixty = (index) => {
    setEventPayload((prevData) => ({
      ...prevData,
      three_sixty: prevData.three_sixty.filter((_, i) => i !== index),
    }));
    toast.success("360 Content Removed!");
  };

  const isSameDate = eventPayload.start_date === eventPayload.end_date;
  const minEndTime = isSameDate
    ? addHoursToTime(eventPayload.start_time, 3)
    : "00:00";

  const eventTypesEnums = enumsData?.data?.eventType
    ? Object.values(enumsData.data.eventType).map((item) => item)
    : [];

  const typeSelectionHandler = (event) => {
    const updatedType = event.target.value;
    if (!updatedType) {
      return toast.error("Please select a type - Event or Coming Soon");
    }
    setSelectedType(updatedType);
    setEventPayload((prevData) => ({
      ...prevData,
      type: updatedType,
    }));
  };

  // reusable progress bar
  const renderUploadProgress = () =>
    videoUploading && (
      <div className="eev-progress">
        <div className="eev-progress-text">Uploading video… {uploadProgress}%</div>
        <div className="eev-progress-bar">
          <div
            className={`eev-progress-fill ${uploadProgress === 100 ? "eev-progress-fill--done" : ""}`}
            style={{ width: `${uploadProgress}%` }}
          />
        </div>
      </div>
    );

  return (
    <MainLayout>
      <div className="eev-wrapper">

        {/* ── Header ── */}
        <div className="eev-header">
          <div className="eev-header-left">
            <div className="eev-header-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
            </div>
            <div>
              <h1 className="eev-title">Edit Event</h1>
              <p className="eev-subtitle">Update the details of this event</p>
            </div>
          </div>
          <button className="eev-view-btn" type="button" onClick={handleNavigationAddTeam}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="8" y1="6" x2="21" y2="6" />
              <line x1="8" y1="12" x2="21" y2="12" />
              <line x1="8" y1="18" x2="21" y2="18" />
              <line x1="3" y1="6" x2="3.01" y2="6" />
              <line x1="3" y1="12" x2="3.01" y2="12" />
              <line x1="3" y1="18" x2="3.01" y2="18" />
            </svg>
            View Event List
          </button>
        </div>

        <form className="eev-form" onSubmit={(e) => e.preventDefault()}>

          {/* ── 01 Event Type ── */}
          <div className="eev-card">
            <div className="eev-card-header">
              <span className="eev-card-badge">01</span>
              <h2 className="eev-card-title">Event Type</h2>
            </div>
            <div className="eev-grid">
              <div className="eev-field eev-field--full">
                <label className="eev-label">Select Type <span className="eev-req">*</span></label>
                <select
                  className="eev-select"
                  name="type"
                  value={eventPayload.type}
                  onChange={typeSelectionHandler}
                >
                  <option value="">Select an Option</option>
                  {Array.isArray(eventTypesEnums) &&
                    eventTypesEnums.map((enums) => (
                      <option key={enums} value={enums}>{ToFirstCapital(enums)}</option>
                    ))}
                </select>
              </div>
            </div>
          </div>

          {/* ── 02 Basic Information ── */}
          <div className="eev-card">
            <div className="eev-card-header">
              <span className="eev-card-badge">02</span>
              <h2 className="eev-card-title">Basic Information</h2>
            </div>
            <div className="eev-grid">
              <div className="eev-field">
                <label className="eev-label">
                  {isTrailer ? "Trailer Name" : "Event Name"} <span className="eev-req">*</span>
                </label>
                <input
                  className="eev-input"
                  type="text"
                  name="event_name"
                  value={eventPayload.event_name}
                  onChange={handleAddChange}
                  placeholder={isTrailer ? "Enter trailer name" : "Enter event name"}
                />
              </div>

              {isComingSoon && (
                <div className="eev-field">
                  <label className="eev-label">Select Builder <span className="eev-req">*</span></label>
                  <select
                    className="eev-select"
                    name="builder"
                    value={eventPayload.builder}
                    onChange={handleAddChange}
                  >
                    <option value="">Select an Option</option>
                    {Array.isArray(builders?.data) &&
                      builders.data.map((builder) => (
                        <option key={builder._id} value={builder._id}>{builder.brand_name}</option>
                      ))}
                  </select>
                </div>
              )}

              <div className="eev-field eev-field--full">
                <label className="eev-label">About <span className="eev-req">*</span></label>
                <textarea
                  className="eev-textarea"
                  name="about_event"
                  value={eventPayload.about_event}
                  onChange={handleAddChange}
                  placeholder="Describe your event"
                  rows={4}
                />
              </div>
            </div>
          </div>

          {/* ── 03 Date & Time ── */}
          <div className="eev-card">
            <div className="eev-card-header">
              <span className="eev-card-badge">03</span>
              <h2 className="eev-card-title">Date &amp; Time</h2>
            </div>
            <div className="eev-grid eev-grid--4">
              <div className="eev-field">
                <label className="eev-label">Start Date <span className="eev-req">*</span></label>
                <input
                  ref={startDateRef}
                  className="eev-input"
                  type="date"
                  name="start_date"
                  value={eventPayload.start_date}
                  onChange={handleAddChange}
                />
              </div>

              <div className="eev-field">
                <label className="eev-label">Start Time <span className="eev-req">*</span></label>
                <input
                  className="eev-input"
                  type="time"
                  name="start_time"
                  value={eventPayload.start_time}
                  onChange={handleAddChange}
                />
              </div>

              <div className="eev-field">
                <label className="eev-label">End Date <span className="eev-req">*</span></label>
                <input
                  className="eev-input"
                  min={eventPayload.start_date}
                  type="date"
                  name="end_date"
                  value={eventPayload.end_date}
                  onChange={handleAddChange}
                />
              </div>

              <div className="eev-field">
                <label className="eev-label">End Time <span className="eev-req">*</span></label>
                <input
                  className="eev-input"
                  min={minEndTime}
                  type="time"
                  name="end_time"
                  value={eventPayload.end_time}
                  onChange={handleAddChange}
                />
              </div>
            </div>
          </div>

          {/* ── 04 Media ── */}
          <div className="eev-card">
            <div className="eev-card-header">
              <span className="eev-card-badge">04</span>
              <h2 className="eev-card-title">Media</h2>
            </div>

            {!isTrailer ? (
              <>
                <div className="eev-grid eev-grid--3">
                  <div className="eev-field">
                    <label className="eev-label">Cover Photo <span className="eev-req">*</span></label>
                    <input
                      id="eev_cover_photo"
                      className="eev-file-hidden"
                      type="file"
                      accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                      name="cover_photo"
                      onChange={(e) => handleMediaUpload(e, "cover_photo", "image")}
                    />
                    <label className="eev-upload" htmlFor="eev_cover_photo">
                      Upload Cover Photo
                    </label>
                    <ImageShowerModalGlobal
                      state={eventPayload}
                      setState={setEventPayload}
                      keyField="cover_photo"
                      file={eventPayload.cover_photo}
                    />
                  </div>

                  <div className="eev-field">
                    <label className="eev-label">Event Image</label>
                    <input
                      id="eev_event_image"
                      className="eev-file-hidden"
                      type="file"
                      accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                      name="event_image"
                      onChange={(e) => handleMediaUpload(e, "event_image", "image")}
                    />
                    <label className="eev-upload" htmlFor="eev_event_image">
                      Upload Event Image
                    </label>
                    <ImageShowerModalGlobal
                      state={eventPayload}
                      setState={setEventPayload}
                      keyField="event_image"
                      file={eventPayload.event_image}
                    />
                  </div>

                  <div className="eev-field">
                    <label className="eev-label">Upload Video</label>
                    <input
                      id="eev_video"
                      className="eev-file-hidden"
                      type="file"
                      name="video"
                      accept="video/mp4, video/avi, video/mov, video/wmv, video/mkv, video/webm"
                      onChange={(e) => handleMediaUpload(e, "video", "video")}
                    />
                    <label className="eev-upload" htmlFor="eev_video">
                      Upload Video
                    </label>

                    {renderUploadProgress()}

                    {eventPayload.video && (
                      <div className="eev-video">
                        <video controls>
                          <source src={eventPayload.video} type="video/mp4" />
                        </video>
                        <button
                          type="button"
                          onClick={handleRemoveVideo}
                          className="eev-video-remove"
                          aria-label="Remove video"
                        >
                          ×
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <div className="eev-grid">
                  <div className="eev-field eev-field--full">
                    <label className="eev-label">Youtube Link</label>
                    <input
                      className="eev-input"
                      type="text"
                      name="youtube_link"
                      value={eventPayload.youtube_link}
                      onChange={handleAddChange}
                      placeholder="https://youtube.com/..."
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* Cover photo is required for trailers as well */}
                <div className="eev-grid">
                  <div className="eev-field">
                    <label className="eev-label">Cover Photo <span className="eev-req">*</span></label>
                    <input
                      id="eev_cover_photo_trailer"
                      className="eev-file-hidden"
                      type="file"
                      accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                      name="cover_photo"
                      onChange={(e) => handleMediaUpload(e, "cover_photo", "image")}
                    />
                    <label className="eev-upload" htmlFor="eev_cover_photo_trailer">
                      Upload Cover Photo
                    </label>
                    <ImageShowerModalGlobal
                      state={eventPayload}
                      setState={setEventPayload}
                      keyField="cover_photo"
                      file={eventPayload.cover_photo}
                    />
                  </div>
                </div>

                {/* Trailer Videos */}
                <div className="eev-subsection">
                  <h3 className="eev-subsection-title">Trailer Videos</h3>
                  <div className="eev-split">
                    <div className="eev-panel">
                      <h4 className="eev-panel-title">Add Trailer Video</h4>

                      <div className="eev-field">
                        <label className="eev-label">Upload Video</label>
                        <input
                          id="eev_trailer_video"
                          className="eev-file-hidden"
                          type="file"
                          name="trailer_video"
                          accept="video/mp4, video/avi, video/mov, video/wmv, video/mkv, video/webm"
                          onChange={(e) => handleMediaUpload(e, "trailer_video", "video")}
                        />
                        <label className="eev-upload" htmlFor="eev_trailer_video">
                          Upload Trailer Video
                        </label>
                      </div>

                      {renderUploadProgress()}

                      {trailerVideoData.url && (
                        <div className="eev-video">
                          <video controls>
                            <source src={trailerVideoData.url} type="video/mp4" />
                          </video>
                          <button
                            type="button"
                            onClick={() => setTrailerVideoData({ ...trailerVideoData, url: "" })}
                            className="eev-video-remove"
                            aria-label="Remove video"
                          >
                            ×
                          </button>
                        </div>
                      )}

                      <button
                        className="eev-btn eev-btn--primary eev-btn--block"
                        disabled={!trailerVideoData.url.trim()}
                        onClick={addTrailerVideoHandler}
                        type="button"
                      >
                        Add Trailer Video
                      </button>
                    </div>

                    <div className="eev-panel eev-panel--scroll">
                      <h4 className="eev-panel-title">Trailer Videos List</h4>
                      {eventPayload?.trailer_videos && eventPayload.trailer_videos.length > 0 ? (
                        <div className="eev-list">
                          {eventPayload.trailer_videos.map((item, index) => (
                            <div className="eev-list-item eev-list-item--stack" key={index}>
                              <div className="eev-list-row">
                                <div className="eev-list-info">
                                  <p className="eev-list-name eev-list-name--wrap">
                                    {item.url.substring(item.url.lastIndexOf("/") + 1)}
                                  </p>
                                  <p className="eev-list-meta">Type: {item.type}</p>
                                </div>
                                <button
                                  type="button"
                                  className="eev-btn eev-btn--remove"
                                  onClick={() => removeTrailerVideo(index)}
                                >
                                  Remove
                                </button>
                              </div>
                              <div className="eev-video eev-video--wide">
                                <video controls>
                                  <source src={item.url} type="video/mp4" />
                                </video>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="eev-empty">No trailer videos added yet</div>
                      )}
                    </div>
                  </div>
                </div>

                {/* 360 VR Content */}
                <div className="eev-subsection">
                  <h3 className="eev-subsection-title">360 VR Content</h3>
                  <div className="eev-split">
                    <div className="eev-panel">
                      <h4 className="eev-panel-title">Add 360 Content</h4>

                      <div className="eev-field">
                        <label className="eev-label">Configuration</label>
                        <input
                          className="eev-input"
                          type="text"
                          name="configuration"
                          value={threeSixtyData.configuration}
                          onChange={(e) =>
                            setThreeSixtyData({ ...threeSixtyData, configuration: e.target.value })
                          }
                          placeholder="Enter configuration"
                        />
                      </div>

                      <div className="eev-field">
                        <label className="eev-label">iFrame URL</label>
                        <input
                          className="eev-input"
                          type="text"
                          name="iframe_url"
                          value={threeSixtyData.iframe_url}
                          onChange={(e) =>
                            setThreeSixtyData({ ...threeSixtyData, iframe_url: e.target.value })
                          }
                          placeholder="Enter iFrame URL"
                        />
                      </div>

                      <label className="eev-check">
                        <input
                          type="checkbox"
                          checked={threeSixtyData.is_user_vr}
                          onChange={(e) =>
                            setThreeSixtyData({ ...threeSixtyData, is_user_vr: e.target.checked })
                          }
                        />
                        Is User VR
                      </label>

                      <button
                        className="eev-btn eev-btn--primary eev-btn--block"
                        disabled={
                          !threeSixtyData.configuration.trim() ||
                          !threeSixtyData.iframe_url.trim()
                        }
                        onClick={addThreeSixtyHandler}
                        type="button"
                      >
                        Add 360 Content
                      </button>
                    </div>

                    <div className="eev-panel eev-panel--scroll">
                      <h4 className="eev-panel-title">360 Content List</h4>
                      {eventPayload?.three_sixty && eventPayload.three_sixty.length > 0 ? (
                        <div className="eev-list">
                          {eventPayload.three_sixty.map((item, index) => (
                            <div className="eev-list-item" key={index}>
                              <div className="eev-list-info">
                                <p className="eev-list-name">{item.configuration}</p>
                                <p className="eev-list-meta">URL: {item.iframe_url}</p>
                                <p className="eev-list-meta">VR: {item.is_user_vr ? "Yes" : "No"}</p>
                              </div>
                              <button
                                type="button"
                                className="eev-btn eev-btn--remove"
                                onClick={() => removeThreeSixty(index)}
                              >
                                Remove
                              </button>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="eev-empty">No 360 content added yet</div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* ── 05 Location ── */}
          <div className="eev-card">
            <div className="eev-card-header">
              <span className="eev-card-badge">05</span>
              <h2 className="eev-card-title">Location</h2>
            </div>
            <div className="eev-grid eev-grid--3">
              <div className="eev-field eev-field--full">
                <MapsAddress
                  value={{
                    address: eventPayload.address,
                    lat: eventPayload.lat,
                    lng: eventPayload.lng,
                  }}
                  onChange={handleAddressChange}
                  showAsterisk={false}
                />
              </div>

              <div className="eev-field">
                <label className="eev-label">Country</label>
                <select
                  className="eev-select"
                  name="country"
                  value={eventPayload.country || ""}
                  onChange={handleAddChange}
                >
                  <option value="">Select an Option</option>
                  {Array.isArray(countryList?.data) &&
                    countryList.data.map((country) => (
                      <option key={country._id} value={country._id}>{country.country_name}</option>
                    ))}
                </select>
              </div>

              <div className="eev-field">
                <label className="eev-label">State</label>
                <select
                  className="eev-select"
                  name="state"
                  value={eventPayload.state || ""}
                  onChange={handleAddChange}
                >
                  <option value="">Select an Option</option>
                  {Array.isArray(states?.data) &&
                    states.data.map((state) => (
                      <option key={state._id} value={state._id}>{state.state_name}</option>
                    ))}
                </select>
              </div>

              <div className="eev-field">
                <label className="eev-label">City</label>
                <select
                  className="eev-select"
                  name="city"
                  value={eventPayload.city || ""}
                  onChange={handleAddChange}
                >
                  <option value="">Select an Option</option>
                  {Array.isArray(cities?.data) &&
                    cities.data.map((city) => (
                      <option key={city._id} value={city._id}>{city.city_name}</option>
                    ))}
                </select>
              </div>
            </div>
          </div>

          {/* ── 06 Guest Details (non-trailer only) ── */}
          {!isTrailer && (
            <div className="eev-card">
              <div className="eev-card-header">
                <span className="eev-card-badge">06</span>
                <h2 className="eev-card-title">Guest Details</h2>
              </div>
              <div className="eev-split">
                <div className="eev-panel">
                  <h3 className="eev-panel-title">Add Guest</h3>

                  <div className="eev-field">
                    <label className="eev-label">Guest Image</label>
                    <input
                      id="eev_guest_image"
                      className="eev-file-hidden"
                      type="file"
                      accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                      onChange={(e) => handleMediaUpload(e, "guest_image", "image")}
                    />
                    <label className="eev-upload" htmlFor="eev_guest_image">
                      Upload Guest Image
                    </label>
                    <ImageShowerModalGlobal
                      state={guestData}
                      setState={setGuestData}
                      keyField="image"
                      file={guestData.image}
                    />
                  </div>

                  <div className="eev-field">
                    <label className="eev-label">Name</label>
                    <input
                      className="eev-input"
                      type="text"
                      name="name"
                      value={guestData.name}
                      onChange={handleGuestAdd}
                      placeholder="Guest name"
                    />
                  </div>

                  <div className="eev-field">
                    <label className="eev-label">Designation</label>
                    <input
                      className="eev-input"
                      type="text"
                      name="designation"
                      value={guestData.designation}
                      onChange={handleGuestAdd}
                      placeholder="e.g. CEO"
                    />
                  </div>

                  <div className="eev-field">
                    <label className="eev-label">Organization</label>
                    <input
                      className="eev-input"
                      type="text"
                      name="organization"
                      value={guestData.organization}
                      onChange={handleGuestAdd}
                      placeholder="e.g. Acme Inc."
                    />
                  </div>

                  <button
                    className="eev-btn eev-btn--primary eev-btn--block"
                    disabled={!guestData.name.trim()}
                    onClick={guestAdditionHandler}
                    type="button"
                  >
                    Add Guest
                  </button>
                </div>

                <div className="eev-panel eev-panel--scroll">
                  <h3 className="eev-panel-title">Guest List</h3>
                  {eventPayload?.guest_list &&
                    eventPayload.guest_list.some((item) => item.name && item.image) ? (
                    <div className="eev-list">
                      {eventPayload.guest_list.map((item, index) =>
                        item.name && item.image ? (
                          <div className="eev-list-item" key={index}>
                            <div className="eev-list-avatar">
                              {item.image ? (
                                <img src={item.image} alt={item.name} />
                              ) : (
                                <span className="eev-list-avatar-letter">
                                  {item.name.charAt(0).toUpperCase()}
                                </span>
                              )}
                            </div>
                            <div className="eev-list-info">
                              <p className="eev-list-name">{item.name}</p>
                              <p className="eev-list-meta">
                                {item.designation}
                                {item.designation && item.organization && " at "}
                                {item.organization}
                              </p>
                            </div>
                            <button
                              type="button"
                              className="eev-btn eev-btn--remove"
                              onClick={() =>
                                setEventPayload((prevData) => ({
                                  ...prevData,
                                  guest_list: prevData.guest_list.filter((_, i) => i !== index),
                                }))
                              }
                            >
                              Remove
                            </button>
                          </div>
                        ) : null
                      )}
                    </div>
                  ) : (
                    <div className="eev-empty">No guests added yet</div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* ── Footer ── */}
          <div className="eev-footer">
            <Link to="/event" className="eev-btn eev-btn--cancel">Cancel</Link>
            <button onClick={handleSubmit} className="eev-btn eev-btn--primary" type="button">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {isTrailer ? "Save Trailer" : isComingSoon ? "Save Coming Soon" : "Save Changes"}
            </button>
          </div>

        </form>
      </div>
    </MainLayout>
  );
};

export default EditEvents;